import React, { useEffect } from 'react'; 
import Navbar from '../Navbar';
import Footer from '../Footer';
import SecurityBody from './SecurityBody';
import { appInsights } from '../../api/AppInsights';

const Security = () => {
  useEffect(() => {
        appInsights.trackPageView({ name: 'Security Page' });
      }, []);
      
  return (
    <>
      <Navbar />
      <SecurityBody />
      <Footer />
    </>
  );
};

export default Security;